if (!customElements.get('mini-cart')) {  
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.cartModalOpen = false;
    }

    connectedCallback() {
      this.cartUrl = this.dataset.cartUrl;
      this.sectionId = this.dataset.sectionId;
      this.cart = JSON.parse(this.dataset.cartJson) || null;
      this.classList.remove('loading');
      
      window.addEventListener('cartGWP:updated', (e) => {
        this.updateCartHtml(e.detail, true);
      });
      
      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
      if (document.readyState === 'complete') this.init();
    }
    
    init() {
      this.addDelegatedClickListeners();
      this.getRecommendedProducts();
    }
    
    addDelegatedClickListeners() { 
      document.addEventListener('click', (e) => {
        if (!this.isConnected) return;
        if (window.location.pathname === this.cartUrl) return;
        if(e.target.closest(`[href="${this.cartUrl}"]`)) {
            e.preventDefault();
            this.open();
            return;
        }
        if (e.target.closest('[data-close-cart]') && this.cartModalOpen) {
            this.close();
            return;
        }
        if (!e.target.closest('mini-cart') && this.cartModalOpen) {
            this.close();
            return;
        }
      });


      window.addEventListener('submit', (e) => {
        const productForm = e.target.closest(`[action="${Shopify.routes.root}cart/add"]`);
        if(!productForm) return;

        e.preventDefault();

        let selling_plan = null;
       //if (productForm.querySelector('[name="selling_plan"]') && productForm.querySelector('[name="selling_plan"]').value !== undefined) selling_plan = productForm.querySelector('[name="selling_plan"]').value;

        let discount = null;
        if (productForm.querySelector('[name="properties[Discount]"]') && productForm.querySelector('[name="properties[Discount]"]').value !== undefined) discount = productForm.querySelector('[name="properties[Discount]"]').value;

        const idToAdd = productForm.querySelector('[name="id"]').value;
        const quantity = productForm.querySelector('[name="quantity"]').value;
        const propertyInputs = productForm.querySelectorAll('[data-form-property]');
        const properties = {};

        if (propertyInputs) {
          for (let input of propertyInputs) {
            const key = input.getAttribute('name').replace(/.*\[(.*)\].*/, '$1');
            const val = input.value;

            properties[key] = val;
          }
        }

        this.classList.add('loading');
        this.addToCart(idToAdd, selling_plan, discount, quantity, properties)
          .then(() => {
            if (document.querySelector('custom-modal')?.activeId) {
              window.dispatchEvent(new CustomEvent('modal:close'));
              setTimeout(() => {
                this.open();
              }, 500);
            } else this.open();
            window.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .finally(() => this.classList.remove('loading'));
      });

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-cart-action]');
        if (!clickedElement) return;

        const {
          cartAction: action,
          lineItemId,
          quantity,
        } = clickedElement.dataset;
        
        switch (action) {
          case 'updateQty':
            const scrollTop = this.querySelector('form')?.scrollTop;

            this.classList.add('loading');
            this.updateQty(lineItemId, Number(quantity))
              .then((res) => {
                if (!res) return;
                this.updateCartHtml(res).then(() => {
                  this.querySelector('form')?.scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
                });
                this.getRecommendedProducts();
                window.dispatchEvent(new CustomEvent('cart:updated'));
              }).finally(() => this.classList.remove('loading'));
          break;
          default: break;
        }
      })
    }
    
    open() {
      this.cartModalOpen = true;
      this.classList.remove('translate-x-full');
      document.querySelector('.section-header').classList.replace('z-10', 'z-[5]');
      if (!window.location.href.includes('/cart')) document.body.classList.add('overlay');

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = '-1';
      
      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = '-1';
      // });
    }

    close() {
      this.cartModalOpen = false;
      this.classList.add('translate-x-full');
      document.querySelector('.section-header').classList.replace('z-[5]', 'z-10');
      document.body.classList.remove('overlay');

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = '31';
      
      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = '31';
      // });
    }
    
    getRecommendedProducts() {
      if (!this.cart?.items.length) return;
      const recommendationsWrapper = this.querySelector('[data-recommended-product-row]');
      if (!recommendationsWrapper) return;
      
      const reccsToRenderPerCartItem = Math.round(5/this.cart.items.length);
      recommendationsWrapper.innerHTML = '';
      
      for (let i = 0; i < this.cart.items.length; i++) {
        const item = this.cart.items[i];
        fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${item.product_id}`)
          .then(response => {
            return response.json()
          })
          .then(({ products }) => {
            const filteredReccs = products
              .filter(({ id, tags }) => {
                return !this.cart.items.find(({ product_id }) => id == product_id) 
                && !tags.some(tag => tag === ('hide_product' || 'base_product'))
              })
              .slice(0, reccsToRenderPerCartItem)
            
              recommendationsWrapper.innerHTML += filteredReccs.map((recc) => {
                return `
                <li>
                  <intersection-loader 
                    data-url="/products/${recc.handle}" 
                    data-section-id="quickbuy-widget"
                    class="bg-silverSand"
                    style="width: 284px; height: 194px;"
                  >
                    <div class="loader">
                      <span class="block w-12 h-12">
                        <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </span>
                    </div>
                  </intersection-loader>
                </li>`;
              }).join('');
          })
      }
    }

    async addToCart(id, selling_plan = null, discount = null, quantity, properties) {      
      const data = {
        id,
        'quantity': quantity,
        sections: [`${this.sectionId}`]
      };

      if (properties && Object.keys(properties).length !== 0) {
        data['properties'] = properties;
        if (discount) data['properties']['Discount'] = discount;
      }

      if (selling_plan) data['selling_plan'] = selling_plan;

      const cartContents = fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.updateCartHtml(json);
          this.getRecommendedProducts();
        })
        .finally((res) => {
          // tracking would go here
        })
        .catch(function(err) {
          console.error(err)
        });

      return cartContents;
    }

    async updateCartHtml(res, updateOnlyProducts = false) {
      let newHtml;
      if (res) {
       newHtml = res?.sections?.[`${this.sectionId}`] ?? res?.sections?.['minicart'];
      } else {
        await fetch(`?${this.sectionId}`).then(res => {
          return res.text();
        }).then((text) => {
          newHtml = text;
        })
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtml;
      
      if (updateOnlyProducts) {
        this.querySelector('[data-cart-items]').innerHTML = tempDiv.querySelector('[data-cart-items]').innerHTML;
      } else {
        this.innerHTML = tempDiv.querySelector('mini-cart').innerHTML;        
      }
      
      const count = Number(tempDiv.querySelector('mini-cart').dataset.cartItemCount) || '';
      this.cart = JSON.parse(tempDiv.querySelector('mini-cart').dataset.cartJson) || null;
      [...document.querySelectorAll('[data-cart-count]')].forEach(cartCount => {
        cartCount.innerHTML = count > 0 ? count : '';
      });     
      
      document.dispatchEvent(new CustomEvent('cart-updated', {
        detail: {
          cart: this.cart,
        }
      }));
    }
    
    async updateQty(id, qty) {
      const updates = {};
      updates[id] = qty;

      const data = {
        updates,
        sections: [`${this.sectionId}`],
      };

      const cartContents = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });

      return cartContents;
    };
  }

  customElements.define('mini-cart', MiniCart);
}